'use client';

import React from 'react';
import CheckoutWrapper from './CheckoutWrapper';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Preloader from '@/features/preloader/components/Preloader';
import GtmClient from '@/features/gtm/GtmClient';
import { useAppSelector } from '@/lib/redux/hooks';
import { useAuth } from '@/features/authentication/hooks/auth';
//

const Checkout = () => {
  const { data: cartSummary, mutate } = useFetcherCSR(
    `/api/v2/web/cart-summary`
  );
  const { user } = useAuth();
  const cartItems = useAppSelector((state) => state.cart.items);
  const cartIds = cartItems.map((item) => item?.id);

  const { data: address, isLoading } = useFetcherCSR(
    `/api/v2/user/shipping/address`
  );

  if (isLoading) {
    return <Preloader />;
  }

  return (
    <>
      <GtmClient
        name="InitiateCheckout"
        data={{
          cart_id: cartIds,
          member_id: user?.data?.id,
          value: cartSummary?.sub_total,
          currency: 'BDT',
        }}
      />
      {/* <FacebookPixelClient
        name="InitiateCheckout"
        data={{
          cart_id: cartIds,
          member_id: user?.data?.id,
          value: cartSummary?.sub_total,
          currency: 'BDT',
        }}
      /> */}
      <section className="page-header">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Cart / Checkout
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section className="checkout padding-bottom">
        <div className="container">
          <div className="checkout__wrapper">
            <div className="checkout__form">
              <CheckoutWrapper
                address={address}
                cartSummary={cartSummary}
                mutate={mutate}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Checkout;
